import React from 'react'

import App from './src/components/App'

export const wrapRootElement = ({ element }) => {
  return <App>{element}</App>
}

export const onServiceWorkerUpdateFound = () => window.location.reload(true);
